module.exports = __webpack_public_path__ + "img/ys_bj_1.25ffc299.png";